import { Children, isValidElement, type ReactNode } from 'react';

const NUMERIC_DISPLAY =
  /^(?:[A-Z]{3}\s+)?[-−(]?\d[\d.,\s]*\)?(?:\s*[kKmMbBtT]|[x×%])?$/;

export function markdownNodeText(node: ReactNode): string {
  if (node == null || typeof node === 'boolean') {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map((child) => markdownNodeText(child)).join('');
  }
  if (isValidElement<{ children?: ReactNode }>(node)) {
    return markdownNodeText(node.props.children);
  }
  return '';
}

export function isNumericTableValue(value: string): boolean {
  return NUMERIC_DISPLAY.test(value.trim());
}

export function isTableTotalRowLabel(value: string): boolean {
  return /^(total|sum)$/i.test(value.trim());
}

export function firstCellText(children: ReactNode): string {
  const [first] = Children.toArray(children);
  return markdownNodeText(first);
}
